import { inViewport, debounce } from './helpers';

let rAF = window.requestAnimationFrame;

function inView({ selector, onEnter, onExit, offset = 0, once = false }) {

  let ticking = false;
  let elements;

  function loop() {
    ticking = false;
    checkElements();
  }

  function checkElements() {
    elements = elements.filter( el => {
      let visible = inViewport( el, offset );
      if ( visible ) {
        onEnter( el );
        if ( once ) {
          return false;
        }
      } else if ( !visible && el.__seen && onExit ) {
        onExit( el );
      }
      el.__seen = visible;
      return true;
    });

    if ( !elements.length ) {
      window.removeEventListener( 'scroll', onScroll );
    }
  }

  function onScroll() {
    if ( !ticking ) {
      ticking = true;
      rAF( loop );
    }
  }

  function onResize() {
    checkElements();
  }

  function setupElements() {
    elements = [ ...document.querySelectorAll( selector ) ];
  }

  function bindEvents() {
    window.addEventListener( 'resize', debounce( onResize, 300 ) );
    window.addEventListener( 'scroll', onScroll );
  }

  function init() {
    const valid = typeof selector === 'string' && typeof onEnter === 'function';
    if ( !valid ) {
      // eslint-disable-next-line max-len
      console.error('Must initialize with valid selector string and onEnter callback');
    }
    setupElements();
    bindEvents();
    checkElements();
  }

  init();

}

export default inView;
